document.addEventListener('click', function (e) {
  const overlay = document.querySelector('.pcm-business-address-overlay');

  if (!overlay) {
    return;
  }

  if (e.target.closest('.pcm-edit-business-address')) {
    e.preventDefault();

    overlay.hidden = false;
    document.body.classList.add('pcm-modal-open');

    return;
  }

  if (
    e.target.closest('.pcm-business-address-close') ||
    e.target.closest('.pcm-business-address-cancel') ||
    (
      e.target === overlay
    )
  ) {
    overlay.hidden = true;
    document.body.classList.remove('pcm-modal-open');
  }
});

document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.pcm-business-address-menu-toggle');
  const menu = document.querySelector('.pcm-business-address-menu');

  if (!menu) {
    return;
  }

  if (toggle) {
    e.preventDefault();
    e.stopPropagation();

    const isOpen = !menu.hidden;

    menu.hidden = isOpen;
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

    return;
  }

  if (!e.target.closest('.pcm-business-address-menu')) {
    menu.hidden = true;

    const button = document.querySelector('.pcm-business-address-menu-toggle');

    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  }
});